import { useEffect } from "react";
import {
    useFloating,
    autoUpdate,
    offset,
    flip,
    shift,
    useDismiss,
    useInteractions,
    FloatingPortal,
} from "@floating-ui/react";
import { Heart, X } from "@phosphor-icons/react";
import { FAVORITE_COLORS } from "@/store/favoritesStore";

export const HeartColorPicker = ({
    activeColor,
    onSelect,
    onClose,
    anchorRef,
    className = "",
}) => {
    const { refs, floatingStyles, context } = useFloating({
        open: true,
        onOpenChange: (isOpen) => {
            if (!isOpen) onClose();
        },
        placement: "left",
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(8),
            flip({ fallbackPlacements: ["bottom-end", "top-end", "right"] }),
            shift({ padding: 8 }),
        ],
    });

    const dismiss = useDismiss(context);
    const { getFloatingProps } = useInteractions([dismiss]);

    useEffect(() => {
        if (anchorRef?.current) {
            refs.setReference(anchorRef.current);
        }
    }, [anchorRef, refs]);

    const handleSelectColor = (hex) => {
        if (activeColor === hex) {
            onSelect(null);
        } else {
            onSelect(hex);
        }
        onClose();
    };

    return (
        <FloatingPortal>
            <div
                ref={refs.setFloating}
                style={floatingStyles}
                {...getFloatingProps()}
                onClick={(e) => e.stopPropagation()}
                data-testid="heart-color-picker"
                className={`z-[9999] flex items-center gap-1.5 bg-white/95 backdrop-blur-md rounded-full shadow-2xl border border-gray-200 px-1.5 py-1 whitespace-nowrap transition-all duration-200 animate-in fade-in zoom-in-95 ${className}`}
            >
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onSelect(null);
                        onClose();
                    }}
                    title="Rəngi ləğv et"
                    className="w-5 h-5 rounded-full bg-red-500 flex text-white items-center justify-center border border-dashed border-gray-300 hover:border-red-500 hover:bg-red-400  transition-all shrink-0"
                >
                    <X size={13} weight="bold" />
                </button>

                <div className="w-[1px] h-3 bg-gray-200 mx-0.5 shrink-0" />

                {/* RƏNG DÜYMƏLƏRİ */}
                {FAVORITE_COLORS.map((c) => {
                    const isSelected = activeColor === c.hex;

                    return (
                        <button
                            key={c.key}
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSelectColor(c.hex);
                            }}
                            data-testid={`heart-color-${c.key}`}
                            className={`w-5 h-5 rounded-full flex items-center justify-center transition-all shrink-0 ${isSelected
                                ? "scale-110 ring-2 ring-offset-1 ring-gray-400"
                                : "hover:scale-110 opacity-75 hover:opacity-100"
                                }`}
                            title={c.key}
                        >
                            <Heart size={17} weight="fill" style={{ color: c.hex }} />
                        </button>
                    );
                })}
            </div>
        </FloatingPortal>
    );
};

export default HeartColorPicker;